import { getInlineNodeViewProducer } from '@atlaskit/editor-common/react-node-view';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { pluginFactory } from '@atlaskit/editor-common/utils';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { DateNodeView } from '../nodeviews/date';
import { DateNodeView as DateNodeViewVanilla } from '../nodeviews/DateNodeView';
import { pluginKey } from './plugin-key';
import { mapping, onSelectionChanged, reducer } from './utils';
var _pluginFactory = pluginFactory(pluginKey, reducer, {
    mapping: mapping,
    onSelectionChanged: onSelectionChanged
  }),
  createPluginState = _pluginFactory.createPluginState,
  getPluginState = _pluginFactory.getPluginState;
var createPlugin = function createPlugin(pmPluginFactoryParams) {
  var dispatch = pmPluginFactoryParams.dispatch;
  var newPluginState = {
    showDatePickerAt: null,
    isNew: false,
    isDateEmpty: false,
    focusDateInput: false
  };
  return new SafePlugin({
    state: createPluginState(dispatch, newPluginState),
    key: pluginKey,
    props: {
      nodeViews: {
        date: function date(node, view, getPos, decorations) {
          if (editorExperiment('platform_editor_vanilla_dom', true, {
            exposure: true
          })) {
            return new DateNodeViewVanilla(node, view, getPos, pmPluginFactoryParams.getIntl());
          }
          return getInlineNodeViewProducer({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: DateNodeView
          })(node, view, getPos, decorations);
        }
      }
    }
  });
};
export { getPluginState };
export default createPlugin;